import axios, { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { IHousingListResponse } from '@/types';
import { GET_SIMILAR_HOUSING_API_ENDPOINT } from '@/constants';

export const useGetSimilarHousing = (
  objectId?: string,
  project?: boolean,
  options?: Partial<UseQueryOptions<IHousingListResponse, AxiosError>>,
) => {
  return useQuery<IHousingListResponse, AxiosError>({
    queryKey: options?.queryKey ?? ['similar-housing', objectId, project],
    queryFn: () =>
      axios
        .get(`${GET_SIMILAR_HOUSING_API_ENDPOINT}/${objectId}`, { params: { limit: 6, project } })
        .then((res) => res.data),
    enabled: Boolean(objectId),
    ...options,
  });
};
